if (!process.env.VUE_APP_IS_WEB) {
  var SyncDesktopTableDB = require("./models/SyncDesktopTable");

  var fs = require("fs");
  var path = require("path");
  var { COPYFILE_EXCL } = fs.constants;
  var uniqid = require("uniqid");
}
import dates from "./dates";
import axios from "axios";
import links from "@/links/links";
import qs from "qs";

export default {
  // NOTE: upsert in desktop DB
  insertOrUpdateInSyncTable(rowUuid, entityName) {
    var objToInsertOrUpdate = {
      row_uuid: rowUuid,
      entity_name: entityName,
      datetime: dates.get_now_utc(),
    };

    return new Promise((resolve, reject) => {
      new SyncDesktopTableDB(objToInsertOrUpdate)
        .where({ row_uuid: rowUuid })
        .upsert()
        .then(res => {
          console.warn("response :: insert or update sync table", res);
          resolve(res.serialize());
        })
        .catch(err => {
          console.error("error :: insert or update sync table", err);
          reject(err);
        });
    });
  },

  // NOTE: get changes
  getWebChanges(appId) {
    return new Promise((resolve, reject) => {
      var queryParams = {
        appId: appId,
      };

      axios
        .get(links.SYNC_TABLE_FETCH(), {
          params: queryParams,
          paramsSerializer: params => {
            return qs.stringify(params);
          },
        })
        .then(res => {
          // console.log("response :: get WEB changes", res);
          resolve(res.data["hydra:member"]);
        })
        .catch(err => {
          console.error("error :: get WEB changes", err);
          reject(err);
        });
    });
  },
  getDesktopChanges() {
    return new Promise((resolve, reject) => {
      new SyncDesktopTableDB()
        .fetchAll()
        .then(res => {
          // console.log("response :: get desktop changes", res);
          resolve(res.serialize());
        })
        .catch(err => {
          console.error("error :: get desktop changes", err);
          reject(err);
        });
    });
  },

  // NOTE: get objects that need to be synced
  getObjectsThatNeedToBeSyncedFromWeb(webChanges) {
    return new Promise((resolve, reject) => {
      axios
        .post(links.SYNC_TABLE_GET_OBJECTS_TO_SYNC(), {
          items: webChanges,
        })
        .then(res => {
          console.log("response :: get objects to sync from WEB", res);
          resolve(res.data["hydra:member"]);
        })
        .catch(err => {
          console.error("error :: get objects to sync from WEB", err);
          reject(err);
        });
    });
  },
  async getObjectsThatNeedToBeSyncedFromDesktop(desktopChanges) {
    var objectsToSync = [];
    var errors = [];

    for (let change of desktopChanges) {
      var tableModel = require(`./models/${change["entity_name"]}`);

      var objectToSync = null;
      await new tableModel({ id: change["row_uuid"] })
        .fetch({ require: false })
        .then(res => {
          objectToSync = res ? res.serialize() : null;
        })
        .catch(err => {
          console.error("error :: get object to sync from DESKTOP", err);
          errors.push(err);
        });

      if (objectToSync) {
        objectToSync["entity_name"] = change["entity_name"];
        if (change["entity_name"] == "Media") {
          objectToSync["file_as_base64_string"] = this.getFileAsBase64String(objectToSync);
        }
      } else if (!objectToSync) {
        if (change["entity_name"] == "Media") {
          objectToSync = {};
          objectToSync["id"] = change["row_uuid"];
          objectToSync["entity_name"] = change["entity_name"];
          objectToSync["deleted_media"] = true;
        }
      }

      if (objectToSync) objectsToSync.push(objectToSync);
    }

    return new Promise((resolve, reject) => {
      if (errors.length == 0) {
        resolve(objectsToSync);
      } else {
        reject(errors);
      }
    });
  },

  // NOTE: sync values
  syncValuesInWebDB(objectsToSync, appId) {
    return new Promise((resolve, reject) => {
      axios
        .post(links.SYNC_TABLE_SYNC_VALUES_IN_DB(appId), {
          items: objectsToSync,
        })
        .then(res => {
          // console.log("response :: sync values in WEB DB", res);
          resolve(res.data["hydra:member"]);
        })
        .catch(err => {
          console.error("error :: sync values in WEB DB", err);
          reject(err);
        });
    });
  },
  async syncValuesInDesktopDB(objectsToSync) {
    var objectsSynced = [];
    var uuidsOfObjectsSynced = [];
    var errors = [];

    for (let objectToSync of objectsToSync) {
      // HACK: ..
      var entityName = objectToSync["entity_name"];
      if (!entityName) entityName = objectToSync["@type"]; // from API Platform (name of entity class)

      delete objectToSync["entity_name"];
      var tableModel = require(`./models/${entityName}`);
      // FIXME: ..
      var ormModel = require(`../store/orm-axios/models/${entityName}`).default;

      objectToSync = this.processDateValues(objectToSync);
      objectToSync = this.ignoreIrrelevantColumns(objectToSync);
      objectToSync = this.processJsonValues(objectToSync);

      if (entityName == "Media" && !objectToSync["deleted_media"]) {
        // !!!: Security ??
        this.writeFileFromBase64String(objectToSync);
      } else if (entityName == "Media" && objectToSync["deleted_media"]) {
        var fileToDelete = null;
        var filePath = null;
        await new tableModel({ id: objectToSync["id"] })
          .fetch({ require: false })
          .then(res => {
            fileToDelete = res ? res.serialize() : null;
            if (fileToDelete) filePath = links.PUBLIC_PATH() + fileToDelete.file_path;
          })
          .catch(err => {
            console.error(err);
          });

        if (fileToDelete && filePath) {
          await new tableModel({ id: fileToDelete.id })
            .destroy({ ignoreEntitySync: true, ignoreEntityTimestampable: true })
            .then(model => {
              var objectSynced = model.previousAttributes();

              fs.unlinkSync(filePath);
              ormModel.delete(fileToDelete.id);

              objectsSynced.push(objectSynced);
            })
            .catch(err => {
              console.error(err);
            });
        }
        uuidsOfObjectsSynced.push(objectToSync["id"]);
      }

      if (!objectToSync["deleted_media"])
        await new tableModel(objectToSync)
          .where({ id: objectToSync["id"] })
          .upsert(null, { ignoreEntitySync: true, ignoreEntityTimestampable: true })
          .then(res => {
            var objectSynced = res.serialize();

            if (objectSynced["deleted"]) {
              ormModel.delete(objectSynced["id"]);
            } else {
              ormModel.insertOrUpdate({
                data: objectSynced,
              });
            }

            objectsSynced.push(objectSynced);
            uuidsOfObjectsSynced.push(objectSynced.id);
          })
          .catch(err => {
            console.error("error :: insert or update object to sync", err);
            errors.push(err);
          });
    }

    return new Promise((resolve, reject) => {
      if (errors.length == 0) {
        resolve(uuidsOfObjectsSynced);
      } else {
        reject(errors);
      }
    });
  },

  // NOTE: delete rows from sync table
  deleteRowsFromWebSyncTable(uuidsOfObjectsSynced, appId) {
    return new Promise((resolve, reject) => {
      axios
        .post(links.SYNC_TABLE_DELETE_ROWS(), {
          row_uuids: uuidsOfObjectsSynced,
          app_id: appId,
        })
        .then(res => {
          // console.log("response :: delete rows from WEB sync table", res);
          resolve(res.data["hydra:member"]);
        })
        .catch(err => {
          console.error("error :: delete rows from WEB sync table", err);
          reject(err);
        });
    });
  },
  async deleteRowsFromDesktopSyncTable(uuidsOfObjectsSynced) {
    var deletedRows = [];
    var errors = [];

    for (let uuidOfObjectSynced of uuidsOfObjectsSynced) {
      await new SyncDesktopTableDB()
        .where({ row_uuid: uuidOfObjectSynced })
        .destroy({ require: false })
        .then(model => {
          // console.log("response :: delete row from sync table", model);
          if (model) deletedRows.push(uuidOfObjectSynced);
        })
        .catch(err => {
          console.error("error :: delete row from sync table", err);
          errors.push(err);
        });
    }

    return new Promise((resolve, reject) => {
      if (errors.length == 0) {
        resolve(deletedRows);
      } else {
        reject(errors);
      }
    });
  },

  // NOTE: *** helper functions ***
  getFileAsBase64String(obj) {
    var filePath = links.PUBLIC_PATH() + obj["file_path"];
    var fileAsBase64String = fs.readFileSync(filePath, { encoding: "base64" });
    var fileType = this.getFileType(obj["filename"]);
    return `data:${fileType};base64,${fileAsBase64String}`;
  },
  writeFileFromBase64String(obj) {
    var base64_code = obj["file_as_base64_string"];
    base64_code = base64_code.split(",");
    var filePath = links.PUBLIC_PATH() + obj["file_path"];

    fs.writeFileSync(filePath, base64_code[1], { encoding: "base64" });
  },
  getFileType(filename) {
    var fileExtension = path.extname(filename);
    if (fileExtension == ".jpg") {
      return "image/jpg";
    } else if (fileExtension == ".jpeg") {
      return "image/jpeg";
    } else if (fileExtension == ".png") {
      return "image/png";
    } else if (fileExtension == ".pdf") {
      return "application/pdf";
    }
  },
  ignoreIrrelevantColumns(obj) {
    // delete obj["id"];
    delete obj["@id"];
    delete obj["@type"];

    return obj;
  },
  processDateValues(obj) {
    if (obj.created) {
      obj.created = dates.format_date_to_utc(obj.created);
    }
    if (obj.updated) {
      obj.updated = dates.format_date_to_utc(obj.updated);
    }
    if (obj.deleted) {
      obj.deleted = dates.format_date_to_utc(obj.deleted);
    }

    return obj;
  },
  processJsonValues(obj) {
    return obj;
  },
  chunkArray(myArray, chunkSize) {
    var arrayLength = myArray.length;
    var tempArray = [];

    for (var index = 0; index < arrayLength; index += chunkSize) {
      let myChunk = myArray.slice(index, index + chunkSize);
      tempArray.push(myChunk);
    }

    return tempArray;
  },
};
